import { MutationTree } from 'vuex';
import { ForexOperationType } from '@/feature/TrHistory/api/forex.interface';
import { ForexHistoryState, ForexCurrency } from '@/feature/TrHistory/store/interface';
import { ForexHistoryMutation } from '@/feature/TrHistory/store/constants';
import { ForexHistoryItem, ForexStatus } from '@/feature/TrHistory/api/forex-history.interface';
import { ForexBuyDraft } from '@/feature/TrHistory/api/form/forex-form.interface';

export default <MutationTree<ForexHistoryState>> {

	[ForexHistoryMutation.addList](state, list: ForexHistoryItem[]) {
		state.list.push(...list);
	},

	[ForexHistoryMutation.setNextPage](state) {
		state.pageNumber++;
	},

	[ForexHistoryMutation.resetPage](state) {
		state.pageNumber = 1;
		state.isEndPage = false;
		state.list = [];
	},

	[ForexHistoryMutation.resetFilter](state) {
		state.fromOperDay = '';
		state.toOperDay = '';
		state.id = null;
		state.fromRequestAmount = null;
		state.toRequestAmount = null;
		state.status = null;
		state.type = null;
		state.currency = null;
	},

	[ForexHistoryMutation.setIsEndPage](state, isEndPage: boolean) {
		state.isEndPage = isEndPage;
	},

	[ForexHistoryMutation.setLoading](state, loading: boolean) {
		state.loadingCount += loading ? 1 : (state.loadingCount && -1);
	},

	[ForexHistoryMutation.deleteItem](state, id: number) {
		const index = state.list.findIndex(draft => draft.foreignExchangeId === id);

		index > -1 && state.list.splice(index, 1);
	},

	[ForexHistoryMutation.setFromOperDay](state, payload: string) {
		state.fromOperDay = payload;
	},

	[ForexHistoryMutation.setToOperDay](state, payload: string) {
		state.toOperDay = payload;
	},

	[ForexHistoryMutation.setId](state, payload: number | null) {
		state.id = payload;
	},

	[ForexHistoryMutation.setFromRequestAmount](state, payload: number | null) {
		state.fromRequestAmount = payload;
	},

	[ForexHistoryMutation.setToRequestAmount](state, payload: number | null) {
		state.toRequestAmount = payload;
	},

	[ForexHistoryMutation.setStatus](state, payload: ForexStatus | null) {
		state.status = payload;
	},

	[ForexHistoryMutation.setType](state, payload: ForexOperationType | null) {
		state.type = payload;
	},

	[ForexHistoryMutation.setCurrency](state, payload: ForexCurrency | null) {
		state.currency = payload;
	},

	[ForexHistoryMutation.updateItem](state, payload: ForexBuyDraft) {
		const item = state.list.find(item =>
			item.foreignExchangeId === payload.foreignExchangeId);

		if (item) {
			Object.assign(item, payload);

			item.loaded = true;
		}
	},

}
